export class PersonalCompanyInfo {
    constructor(
        public graduateYear: string = '',
        public institutionOfGraduation: string = '',
        public  yearsOfExperience:string = '',
        public nameOfCompany:string =''
    ){}
}
